import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import useStyles, { color } from './styles';

export default function GenericAlert({ alertText, type }) {
  const classes = useStyles();

  return (
    <Typography
      style={{
        background: `${color[type]}`,
      }}
      className={classes.alert}
    >
      {alertText}
    </Typography>
  );
}

GenericAlert.propTypes = {
  alertText: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
